<div class="details-edit-container properties">
    <form name="autoForm" class="form-container" novalidation>
        <header ng-if="vm.formConfig.formTitle">
            <h1>{{vm.formConfig.formTitle}}</h1>
            <p ng-if="vm.formConfig.customLink">
                <a ng-if="vm.formConfig.customLink.link" href="{{vm.formConfig.customLink.link}}" target="_blank">{{vm.formConfig.customLink.text}}</a>
                <span ng-if="!vm.formConfig.customLink.link">{{vm.formConfig.customLink.text}}</span>
            </p>
            <p class="form-description" ng-if="vm.formConfig.formDescription">{{vm.formConfig.formDescription}}</p>
        </header>
        <c-auto-form-section section="section" ng-repeat="section in vm.formConfig.sections"></c-auto-form-section>
    </form>
</div>